<template>
  <div class="publicity-page">
    <!-- 首屏主视觉：logo / 主标语 / 保安形象 / 平台优势标签 -->
    <img
      src="../../../static/publicity-bg1.png"
      alt="咖德安保 不止有保安好活儿 还能赚积分"
      class="publicity-hero"
    />
    <div class="cta-wrap cta-first">
      <img
        src="../../../static/publicity-btn1.png"
        alt="点击查看更多好岗位"
        class="cta-btn"
        @click="onMoreJobs"
      />
    </div>

    <!-- 平台优势 -->
    <div class="adv-section">
      <div class="adv-badge"><i></i>优势</div>
      <div class="adv-title">为什么这么多保安兄弟都选我们?</div>
      <div class="adv-sub">专做保安招聘·更懂保安需求</div>

      <!-- 优势1：垂直专注 -->
      <div class="adv-card">
        <img src="../../../static/publicity-one.png" alt="" class="card-num" />
        <span class="card-tag">垂直专注</span>
        <div class="card-title">只做保安招聘，不瞎忽悠</div>
        <p class="card-desc">
          我们深耕保安行业多年，了解每一个岗位的真实情况，绝不虚假宣传！各种应聘的好活儿我们都有，不信你就来看看吧~
        </p>
        <!-- 服务场景：一屏约4个，可左右滑动 -->
        <div class="scene-scroll">
          <div class="scene-tile">
            <img src="../../../static/publicity-icon1.png" alt="" />
            <span>商场</span>
          </div>
          <div class="scene-tile">
            <img src="../../../static/publicity-icon2.png" alt="" />
            <span>小区</span>
          </div>
          <div class="scene-tile">
            <img src="../../../static/publicity-icon3.png" alt="" />
            <span>写字楼</span>
          </div>
          <div class="scene-tile">
            <img src="../../../static/publicity-icon4.png" alt="" />
            <span>学校</span>
          </div>
          <div class="scene-tile">
            <img src="../../../static/publicity-icon5.png" alt="" />
            <span>工厂</span>
          </div>
          <div class="scene-tile">
            <img src="../../../static/publicity-icon6.png" alt="" />
            <span>其他</span>
          </div>
        </div>
      </div>

      <!-- 优势2：智能筛选 -->
      <div class="adv-card">
        <img
          src="../../../static/publicity-two.png"
          alt=""
          class="card-num two"
        />
        <span class="card-tag">智能筛选</span>
        <div class="card-title">岗位多，按你要的选</div>
        <p class="card-desc">
          海量真实岗位，按你的需求精准筛选，找到最合适你的好活儿，你想要的，我们统统都有！
        </p>
        <div class="filter-pills">
          <span class="pill pill-1">离家近</span>
          <span class="pill pill-2">工资高</span>
          <span class="pill pill-3">包吃住</span>
          <span class="pill pill-4">有五险</span>
          <span class="pill pill-5">长白班</span>
          <span class="pill pill-6">其他</span>
        </div>
      </div>

      <!-- 急招岗位轮播 -->
      <el-carousel
        class="job-carousel"
        height="21.4vw"
        :interval="4000"
        arrow="never"
        indicator-position="outside"
      >
        <el-carousel-item v-for="(job, index) in jobList" :key="index">
          <div class="job-card">
            <div class="job-head">
              <span class="job-tag">{{ job.tag }}</span>
              <span class="job-title">{{ job.title }}</span>
              <span class="job-salary">{{ job.salary }}</span>
            </div>
            <div class="job-meta">
              <span v-for="(meta, i) in job.meta" :key="i">{{ meta }}</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="cta-wrap cta-mid">
        <img
          src="../../../static/publicity-btn1.png"
          alt="点击查看更多好岗位"
          class="cta-btn"
          @click="onMoreJobs"
        />
      </div>
    </div>

    <!-- 蓝紫渐变背景带：二维码 + 关于我们 -->
    <div class="band-section">
      <!-- 二维码下载 / 客服 -->
      <div class="qr-section">
        <div class="qr-col">
          <p class="qr-title">下载APP<br />查看更多轻松好活儿</p>
          <img
            src="../../../static/publicity-app.png"
            alt="下载APP二维码"
            class="qr-img"
          />
          <p class="qr-tip">长按识别下载APP</p>
        </div>
        <div class="qr-col">
          <p class="qr-title">一对一免费推荐岗位<br />24小时贴心服务</p>
          <img
            src="../../../static/publicity-kefu.png"
            alt="客服二维码"
            class="qr-img"
          />
          <p class="qr-tip">长按识别二维码</p>
        </div>
      </div>

      <!-- 关于我们 -->
      <div class="about-section">
        <div class="about-title"><span>关于我们</span></div>
        <div class="about-card">
          <img
            src="../../../static/publicity-about.webp"
            alt="ABOUT US"
            class="about-banner"
          />
          <p>
            我们是一家专注保安招聘的求职平台，融合智慧安全与物联网技术，搭建保安企业与保安员的直聘桥梁。
          </p>
          <p>
            平台聚焦保安垂直直聘，对用工企业、岗位信息双重审核；覆盖写字楼、园区、商场、临勤日结等多种岗位类。
          </p>
          <p>
            助力保安企业管理，链接智慧安防管理平台，实现数字化管理人及、商、事项目的一体化；依托数字化能力，简化投递、沟通、面试全流程；同时上线积分激励、岗位资讯等服务，全方位服务广大安保从业者和保安企业。
          </p>
        </div>
        <div class="cta-wrap">
          <img
            src="../../../static/publicity-btn2.png"
            alt="专注保安招聘·同城直招 免费查附近保安岗位"
            class="cta-btn"
            @click="onNearbyJobs"
          />
        </div>
      </div>
    </div>

    <!-- 备案页脚 -->
    <footer class="publicity-footer">
      <p>@2025 北京咖德蔚来科技有限公司</p>
      <p>京ICP备2023024151号-1京公网安备号 11030102011656</p>
    </footer>

    <!-- 微信环境未配置 URL Link 时的小程序口令引导弹窗 -->
    <div class="mp-guide" v-if="showMpGuide" @click.self="showMpGuide = false">
      <div class="mp-guide-box">
        <p class="mp-guide-title">前往咖德安保小程序</p>
        <p class="mp-guide-desc">
          复制下方口令，粘贴发送给任意微信聊天（如文件传输助手），点击聊天中的小程序卡片即可进入
        </p>
        <div class="mp-guide-token">{{ mpToken }}</div>
        <div class="mp-guide-btns">
          <span class="mp-guide-copy" @click="copyMpToken">复制口令</span>
          <span class="mp-guide-close" @click="showMpGuide = false">关闭</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 岗位接口域名：api-uat；开发环境经 /job-api 代理转发（见 config/index.js）
const JOB_API_BASE =
  process.env.NODE_ENV === "production"
    ? "https://api.baoanlailou.com"
    : "/job-api";

// 咖德安保微信小程序配置
const MINI_PROGRAM = {
  // 外部浏览器唤起微信用：小程序后台「工具 → URL Scheme」生成的长期有效链接
  scheme: "weixin://dl/business/?appid=wxe157bc5ff5628b57", // TODO: 替换为真实 URL Scheme
  // 微信浏览器内直接拉起小程序：小程序后台生成的 URL Link（https://wxaurl.cn/xxx）
  // 注意：口令（#小程序://...）不是 URL Link，不能用于 location.href
  urlLink: "", // TODO: 替换为真实 URL Link
  // 未配置 URL Link 时的兜底：小程序口令，粘贴到微信聊天中可打开小程序
  mpToken: "#小程序://咖德安保/dC5Tv3M5noMuWhC",
  // 系统配置 propName：服务端调微信 urllink.generate 生成链接后存入系统配置，
  // propValue 可为纯链接或 JSON {"urlLink":"https://wxaurl.cn/xx","scheme":"weixin://dl/business/?t=xx"}
  urlLinkPropName: "H5MiniProgramUrlLink", // TODO: 与后端系统配置中配置的 propName 对齐
  // 已在小程序 web-view 内时切换的 tabBar 页面
  homePath: "/pages/indexList/indexList"
};

export default {
  name: "publicity",
  data() {
    return {
      // 小程序口令引导弹窗
      showMpGuide: false,
      mpToken: MINI_PROGRAM.mpToken,
      // 从系统配置拉取的小程序拉起链接缓存 {urlLink, scheme}
      mpLinks: null,
      // 轮播岗位默认示例数据，接口返回后替换
      jobList: [
        {
          tag: "加急",
          title: "急招中控员，45岁以下",
          salary: "7000/月",
          meta: ["消防中控", "月结", "45岁以下", "1人"]
        },
        {
          tag: "急招",
          title: "写字楼安保员，包吃住",
          salary: "6500/月",
          meta: ["写字楼", "包吃住", "40岁以下", "2人"]
        },
        {
          tag: "新上",
          title: "小区门岗，长白班",
          salary: "6000/月",
          meta: ["小区", "长白班", "50岁以下", "3人"]
        }
      ]
    };
  },
  mounted() {
    this.getJobList();
    this.setNum();
    // 预拉取小程序拉起链接，点击按钮时可直跳无等待
    this.getMpLinks();
  },
  methods: {
    setNum() {
      this.$axios
        .post("/mapi/api/statistice/h5-adPage-statis")
        .then(({ data }) => {
          console.log(data);
        });
    },
    // 获取急招岗位轮播数据
    getJobList() {
      // 用 per-request baseURL 覆盖实例默认的 /dev-api，避免前缀叠加
      this.$axios
        .post(`/mapi/api/job/guard/index/page`, { page: 1, pageSize: 3 })
        .then(({ data }) => {
          console.log(data);
          const rows = (data && (data.items || data.list || data.rows)) || [];
          if (!rows.length) return;
          this.jobList = rows.map(item => {
            const meta = Array.isArray(item.meta)
              ? item.meta
              : [
                  item.jobType,
                  item.payType,
                  item.ageLimit,
                  item.peopleNum
                ].filter(v => v !== null && v !== undefined && v !== "");
            return {
              tag: item.tag || item.jobTag || "",
              title: item.jobName || item.title || item.postName || "",
              salary: item.salary || item.salaryDesc || "",
              meta
            };
          });
        })
        .catch(() => {})
        .finally();
    },
    // 环境检测：小程序 web-view / 微信浏览器 / 普通浏览器
    detectEnv() {
      const ua = navigator.userAgent;
      const isWeChat = /MicroMessenger/i.test(ua);
      if (isWeChat && /miniProgram/i.test(ua)) return "miniprogram";
      if (isWeChat) return "wechat";
      return "browser";
    },
    // 打开咖德安保微信小程序
    openMiniProgram() {
      const env = this.detectEnv();
      // 已在小程序 web-view 中：直接切到小程序首页
      if (env === "miniprogram") {
        if (window.wx && window.wx.miniProgram) {
          window.wx.miniProgram.switchTab({ url: MINI_PROGRAM.homePath });
        }
        return;
      }
      // 微信浏览器：URL Link 可直接拉起小程序；未配置时自动复制口令并弹引导弹窗
      // 普通浏览器：URL Scheme 唤起微信打开小程序
      // 链接优先取系统配置下发值，拉取完成后再决策跳转
      this.getMpLinks().then(() => {
        if (env === "wechat") {
          const urlLink = this.resolveMpLink("urlLink");
          if (/^https?:\/\//.test(urlLink)) {
            location.href = urlLink;
          } else {
            this.showMpGuide = true;
            this.autoCopyToken();
          }
          return;
        }
        const scheme = this.resolveMpLink("scheme");
        if (/^weixin:\/\//.test(scheme)) {
          location.href = scheme;
        } else {
          console.warn("未配置小程序 URL Scheme");
        }
      });
    },
    // 系统配置下发值优先，静态常量作兜底
    resolveMpLink(key) {
      return (this.mpLinks && this.mpLinks[key]) || MINI_PROGRAM[key] || "";
    },
    // 从系统配置拉取小程序拉起链接（服务端存 urllink.generate 结果），成功后缓存
    getMpLinks() {
      if (this.mpLinks) return Promise.resolve(this.mpLinks);
      return this.$axios
        .post(
          `/mapi/api/common/by/prop-name`,
          { propName: MINI_PROGRAM.urlLinkPropName },
          { noToken: true }
        )
        .then(({ data }) => {
          const raw =
            data &&
            data.sysConfVO &&
            data.sysConfVO[0] &&
            data.sysConfVO[0].propValue;
          this.mpLinks = this.parseMpLinks(raw);
          return this.mpLinks;
        })
        .catch(() => {});
    },
    // propValue 兼容三种格式：纯 URL Link / 纯 URL Scheme / 含两者的 JSON
    parseMpLinks(raw) {
      if (!raw) return {};
      const text = String(raw).trim();
      if (/^https?:\/\//.test(text)) return { urlLink: text };
      if (/^weixin:\/\//.test(text)) return { scheme: text };
      try {
        const obj = JSON.parse(text);
        return obj && typeof obj === "object" ? obj : {};
      } catch (e) {
        return {};
      }
    },
    // 复制文本到剪贴板（微信内置浏览器不支持 clipboard API，用 execCommand 兜底）
    execCopy(text) {
      const input = document.createElement("textarea");
      input.value = text;
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      let ok = false;
      try {
        ok = document.execCommand("copy");
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(input);
      return ok;
    },
    copyMpToken() {
      const ok = this.execCopy(this.mpToken);
      this.$message(
        ok
          ? "口令已复制，请粘贴到微信聊天中打开"
          : "复制失败，请长按口令手动复制"
      );
    },
    // 弹窗打开时在同一点击手势内自动复制口令，减少一步手动操作
    autoCopyToken() {
      if (this.execCopy(this.mpToken)) {
        this.$message("口令已复制，粘贴到任意微信聊天后点击卡片即可进入");
      }
    },
    // 点击查看更多好岗位
    onMoreJobs() {
      this.openMiniProgram();
    },
    // 免费查附近保安岗位
    onNearbyJobs() {
      this.openMiniProgram();
    }
  }
};
</script>

<style scoped>
.publicity-page {
  min-height: 100vh;
  padding: 0;
  margin: 0;
  background: url("../../../static/publicity-bg2.png") no-repeat top center /
    100% 100%;
}
.publicity-hero {
  width: 100%;
  display: block;
}
/* 渐变按钮通用 */
.cta-wrap {
  padding: 4vw 5.2vw 0;
}
/* 首屏按钮：落入 bg1 底部预留的留白区内 */
.cta-first {
  margin: -23.2vw 0 12.5vw;
  padding-top: 0;
}
.cta-mid {
  padding-top: 7.5vw;
}
.cta-btn {
  width: 100%;
  display: block;
  animation: cta-breathe 2.4s ease-in-out infinite;
  will-change: transform;
}
/* 呼吸效果：缩放 + 光晕起伏 */
@keyframes cta-breathe {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0 rgba(106, 92, 255, 0));
  }
  50% {
    transform: scale(1.045);
    filter: drop-shadow(0 0.8vw 2.4vw rgba(106, 92, 255, 0.45));
  }
}
.cta-btn:active {
  opacity: 0.85;
  animation: none;
  transform: scale(0.97);
}

/* 平台优势 */
.adv-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 5.3vw;
  padding: 0.7vw 2.6vw;
  border-radius: 999px;
  background: linear-gradient(90deg, #4d8dff, #6a5cff);
  color: #fff;
  font-size: 2.4vw;
}
.adv-badge i {
  width: 1.2vw;
  height: 1.2vw;
  margin-right: 1.2vw;
  border-radius: 50%;
  background: #fff;
}
.adv-title {
  margin: 3vw 5.3vw 0;
  font-size: 5vw;
  font-weight: 700;
  color: #2f3850;
}
.adv-sub {
  margin: 2.2vw 5.3vw 0.8vw;
  font-size: 3.2vw;
  color: #5a6478;
}
.adv-card {
  position: relative;
  overflow: hidden;
  margin: 5.4vw 5.3vw 0;
  padding: 4.5vw 3.5vw;
  border-radius: 2.6vw;
  background: #fff;
  box-shadow: 0 0.533vw 2vw rgba(80, 100, 180, 0.08);
}
.card-num {
  position: absolute;
  top: 5.6vw;
  right: 6.3vw;
  width: 5.9vw;
}
.card-num.two {
  width: 7.5vw;
}
.card-tag {
  display: inline-block;
  padding: 1.2vw 2.4vw 1.2vw 3.2vw;
  border-radius: 0.8vw;
  background: #2b3252;
  color: #f0c163;
  font-size: 3.2vw;
  font-weight: 600;
  letter-spacing: 0.8vw;
}
.card-title {
  margin-top: 3.4vw;
  font-size: 4.3vw;
  font-weight: 700;
  color: #2f3850;
}
.card-desc {
  margin: 2.9vw 0 0;
  font-size: 3.2vw;
  line-height: 1.85;
  color: #8a94a6;
}
/* 服务场景：横向滑动，一屏约4个 */
.scene-scroll {
  display: flex;
  gap: 2.9vw;
  margin: 2.9vw -3.5vw 0;
  padding: 0 3.5vw;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.scene-scroll::-webkit-scrollbar {
  display: none;
}
.scene-tile {
  flex: 0 0 19.8vw;
  box-sizing: border-box;
  height: 20vw;
  padding-top: 3vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 1.7vw;
  background: #f4f6fb;
}
.scene-tile img {
  width: 9.2vw;
  display: block;
}
.scene-tile span {
  margin-top: 1.6vw;
  font-size: 3.2vw;
  line-height: 1.4;
  color: #3a4664;
}
.filter-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 3.4vw 3.5vw;
  margin-top: 4.6vw;
}
.pill {
  width: calc((100% - 7vw) / 3);
  padding: 2.5vw 0;
  border-radius: 1.3vw;
  text-align: center;
  color: #fff;
  font-size: 3.6vw;
  font-weight: 600;
}
.pill-1 {
  background: linear-gradient(135deg, #6468f0, #7d8cf8);
}
.pill-2 {
  background: linear-gradient(135deg, #4d7bf0, #3fa0f0);
}
.pill-3 {
  background: linear-gradient(135deg, #1898e8, #20c0e8);
}
.pill-4 {
  background: linear-gradient(135deg, #18c0b0, #40d0b0);
}
.pill-5 {
  background: linear-gradient(135deg, #9048f0, #b070f8);
}
.pill-6 {
  background: linear-gradient(135deg, #f06878, #f89068);
}

/* 急招岗位轮播 */
.job-carousel {
  margin: 5.4vw 5.2vw 0;
}
.job-card {
  height: 100%;
  box-sizing: border-box;
  padding: 3.5vw 3.2vw 4.5vw;
  border: 0.43vw solid transparent;
  border-radius: 2.6vw;
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(90deg, #4d8dff, #35d59c) border-box;
}
.job-head {
  display: flex;
  align-items: center;
  gap: 2vw;
  line-height: 1.4;
}
.job-tag {
  padding: 0.7vw 2vw;
  border-radius: 1vw;
  background: linear-gradient(90deg, #ff9330, #ff5f3c);
  color: #fff;
  font-size: 3.2vw;
  font-weight: 600;
}
.job-title {
  flex: 1;
  font-size: 3.9vw;
  font-weight: 700;
  color: #2f3850;
}
.job-salary {
  font-size: 4vw;
  font-weight: 700;
  color: #f23850;
}
.job-meta {
  display: flex;
  gap: 2.4vw;
  margin-top: 3.5vw;
  line-height: 1.4;
}
.job-meta span {
  padding: 0.8vw 1.6vw;
  border-radius: 0.85vw;
  background: #eef1f6;
  color: #6a7280;
  font-size: 3.2vw;
}

/* 蓝紫渐变背景带 */
.band-section {
  margin-top: 8.9vw;
  padding: 8vw 0 8.6vw;
  background: linear-gradient(180deg, #d9e7fb 0%, #e4def6 45%, #f8ecf2 100%);
}

/* 二维码区域 */
.qr-section {
  display: flex;
  justify-content: center;
  gap: 12.4vw;
}
.qr-col {
  flex: 0 0 34vw;
  text-align: center;
}
.qr-title {
  margin: 0;
  font-size: 3.4vw;
  font-weight: 600;
  line-height: 1.65;
  color: #3a4664;
}
.qr-img {
  width: 34vw;
  margin-top: 3.2vw;
  display: inline-block;
}
.qr-tip {
  margin: 4.1vw 0 0;
  font-size: 3.2vw;
  color: #8a93a6;
}

/* 关于我们 */
.about-title {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2.1vw;
  margin-top: 7.2vw;
}
.about-title::before,
.about-title::after {
  content: "";
  width: 17vw;
  height: 0.43vw;
  border-radius: 999px;
}
.about-title::before {
  background: linear-gradient(90deg, rgba(176, 107, 255, 0), #a06bff);
}
.about-title::after {
  background: linear-gradient(90deg, #a06bff, rgba(176, 107, 255, 0));
}
.about-title span {
  font-size: 4.5vw;
  font-weight: 700;
  color: #2f3850;
}
.about-card {
  margin: 4.8vw 5.3vw 0;
  padding: 3vw;
  border-radius: 2.6vw;
  background: #fff;
  box-shadow: 0 0.533vw 2vw rgba(80, 100, 180, 0.08);
}
.about-banner {
  width: 100%;
  border-radius: 1.6vw;
  display: block;
}
.about-card p {
  margin: 4vw 0 0;
  font-size: 3.4vw;
  line-height: 1.85;
  color: #3a4664;
  text-align: justify;
}
.about-banner + p {
  margin-top: 6.5vw;
}
.about-section .cta-wrap {
  padding: 9.6vw 5.2vw 0;
}

/* 备案页脚 */
.publicity-footer {
  padding: 6.4vw 3.2vw;
  background: #272e4d;
}
.publicity-footer p {
  margin: 0;
  font-size: 3.2vw;
  line-height: 1.85;
  text-align: center;
  color: #fff;
}

/* 小程序口令引导弹窗 */
.mp-guide {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}
.mp-guide-box {
  width: 78vw;
  padding: 6vw 5vw 5vw;
  border-radius: 3vw;
  background: #fff;
  text-align: center;
}
.mp-guide-title {
  font-size: 4.3vw;
  font-weight: 700;
  color: #2f3850;
}
.mp-guide-desc {
  margin-top: 2.6vw;
  font-size: 3.2vw;
  line-height: 1.7;
  color: #5a6478;
  text-align: left;
}
.mp-guide-token {
  margin-top: 3.6vw;
  padding: 2.8vw 2vw;
  border: 0.3vw dashed #6468f0;
  border-radius: 1.6vw;
  background: #f4f6fb;
  font-size: 3.4vw;
  color: #6468f0;
  word-break: break-all;
}
.mp-guide-btns {
  display: flex;
  gap: 3vw;
  margin-top: 4.6vw;
}
.mp-guide-btns span {
  flex: 1;
  padding: 2.6vw 0;
  border-radius: 999px;
  font-size: 3.6vw;
  font-weight: 600;
}
.mp-guide-copy {
  background: linear-gradient(90deg, #6468f0, #4d8dff);
  color: #fff;
}
.mp-guide-close {
  background: #eef1f6;
  color: #5a6478;
}
</style>

<style>
/* 岗位轮播指示器：设计稿宽短横条样式 */
.job-carousel .el-carousel__indicators--outside {
  margin-top: 3.5vw;
  text-align: center;
}
.job-carousel .el-carousel__indicator--horizontal {
  padding: 0 1.4vw;
}
.job-carousel .el-carousel__indicator--horizontal button {
  width: 4.5vw;
  height: 1.1vw;
  border-radius: 999px;
  background: #ccd2ec;
  opacity: 1;
  transition: all 0.3s;
}
.job-carousel .el-carousel__indicator--horizontal.is-active button {
  width: 4.7vw;
  background: #6468f0;
}
</style>



// WEBPACK FOOTER //
// src/view/publicity/publicity.vue